import type { StyleRule } from '@archipro-design/aria';
import { pxToRem } from '@archipro-design/aria';

export const ModuleContainer: StyleRule<{
    maxFrameHeight: number;
}> = ({ maxFrameHeight }) => ({
    minHeight: pxToRem(maxFrameHeight),
});
